import React from 'react'

export default function Topics() {
  return (
    <div>Topics</div>
  )
}
